import { environment } from 'src/environments/environment';

const API_PATHS = {
  SEND_OTP: '/api/auth/send-otp',
  VERIFY_OTP: '/api/auth/login',
  LOGIN: '/api/auth/login',
  REFRESH_TOKEN: '/api/auth/refresh',
  CUSTOMERS: '/api/v3/users',
  ADD_CHARGERS: '/api/chargers',
  CHARGERS: '/api/chargers',
  USER_DETAILS: '/api/users/:userId',
  APPROVE_VEHICLE: '/api/vehicles/:vehicleId/approve',
  REJECT_VEHICLE: '/api/vehicles/:vehicleId/reject',
  UPDATE_VEHICLE: '/api/vehicles/:vehicleId',
}

export const URLS = Object.fromEntries(
  Object.entries(API_PATHS).map(([key, value]) => [
    key,
    `${environment.API_BASE_URL}${value}`,
  ])
) as Record<keyof typeof API_PATHS, string>;

export const buildUrl = (
  path: string,
  params: Record<string, string | number>
): string => {
  let url = path;

  Object.entries(params).forEach(([key, value]) => {
    url = url.replace(`:${key}`, encodeURIComponent(String(value)));
  });

  return url;
};
